import { Flex, GatsbyImage, Link, Text, Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverBody, useClipboard } from '@stars-ecom/shared-atoms-ui'
import React, { memo, useEffect } from 'react'
import { navigate } from 'gatsby'

import { DataLayerUtils } from '../context'

const CollectionPush = (props) => {
  const { collection } = props

  const { onCopy, hasCopied } = useClipboard(collection?.customFields?.insertToCollectionCodePromo || "")

  useEffect(() => {
    if (collection?.customFields?.insertToCollectionImage) {
        DataLayerUtils.addPromotionImpression({
            promotionName: `Push collection ${collection.name}`,
            promotionCreative: collection?.customFields?.insertToCollectionImage?.source,
            promotionPosition: 0,
            promotionId: collection.id
        })
    }
  }, [])

    return (
        <Flex position="relative" m="auto" direction="column" bg="#fff" border="1px solid #e7e7e7" cursor="pointer" onClick={() => navigate(`${collection?.customFields?.insertToCollectionLink}`)}>
            <Flex h={{ base: '240px', md: 'auto'}} alignSelf="center">
                <GatsbyImage
                    image={
                        collection?.customFields?.insertToCollectionImage?.image?.childImageSharp?.gatsbyImageData
                    }
                    loading="eager"
                    alt="image-push"
                    title="image-push"
                />
            </Flex>
            {collection?.customFields?.labelButton && (
                <Flex direction="column" fontSize={{ base: '14px', md: '16px' }} bg="whiteAlpha.700" position="absolute" bottom="0" cursor="pointer" w="100%" p="6px" alignItems="center" alignSelf="center" justifyContent="center">
                    <Text mb="8px" textAlign="center" lineHeight="normal">{collection?.customFields?.captionButton}</Text>
                    <Flex p={{ base:'4px 8px', md:'4px 16px'}} border="1px solid #000" color="#fff" bg="#000" _hover={{ bg:"#fff", color:"#000", transition: "all .3s" }}>
                        { collection?.customFields?.insertToCollectionCodePromo ? (
                            <Popover isOpen={hasCopied} placement="top" closeOnBlur={true}>
                                <PopoverTrigger>
                                    <Flex 
                                        bg="transparent" 
                                        cursor="pointer"
                                        onClick={(e) => {
                                            e.stopPropagation() 
                                            onCopy()
                                        }}
                                        _hover={{ bg: "#fff", color: "#000", transition: "all .3s" }}>
                                        <Text transition="transform 0.2s ease-in-out" _hover={{ transform: 'scale(1.1)' }}>
                                            {collection?.customFields?.labelButton}
                                        </Text>
                                    </Flex>
                                </PopoverTrigger>
                                <PopoverContent bg="#fff" color="#000" border="none" w="fit-content">
                                    <PopoverArrow bg="#fff" />
                                    <PopoverBody fontSize="sm">Copié !</PopoverBody>
                                </PopoverContent>
                            </Popover> 
                            ) : (
                            <Link to={collection?.customFields?.insertToCollectionLink ? collection?.customFields?.insertToCollectionLink : "/"}> {collection?.customFields?.labelButton} </Link>
                        )}
                    </Flex>
                </Flex>
            )}    
        </Flex>
    )
}

export default memo(CollectionPush)
